/* istanbul ignore file */
import React from 'react';
import AccountsBreadcrumbs from 'domain/sales/account/shared/AccountsBreadcrumbs';
import { useFormContext } from 'framework/form';
import { SingleBreadcrumbItem, UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useAccountUrl } from 'domain/shared/account';

const UpdateAccountBreadcrumbs = () => {
  const { data = {} } = useFormContext();
  const { getSingleEntityUrl } = useAccountUrl();

  return (
    <AccountsBreadcrumbs>
      <SingleBreadcrumbItem entity={data.accountName || data.accountId} link={getSingleEntityUrl(data.id)} />
      <UpdateBreadcrumbItem />
    </AccountsBreadcrumbs>
  );
};

export default UpdateAccountBreadcrumbs;
